<template>
  <admin-card title="Создание теста" :show-partners-block="false">
    <form @submit.prevent="create" @keydown="form.onKeydown($event)">
      <!-- Test Title -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_title') }}</label>
        <div class="col-md-7">
          <input v-model="form.title" type="text" name="title" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('title') }">
          <has-error :form="form" field="title"></has-error>
        </div>
      </div>

      <!-- About test -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_description') }}</label>
        <div class="col-md-7">
          <input v-model="form.description" type="text" name="description" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('description') }">
          <has-error :form="form" field="description"></has-error>
        </div>
      </div>

      <!-- About test -->
      <div class="form-group row">
        <label class="col-md-3 col-form-label text-md-right">{{ $t('test_allowable_mistakes_count') }}</label>
        <div class="col-md-7">
          <input v-model="form.allowable_mistakes_count" type="number" min="0" max="100" name="allowable_mistakes_count" class="form-control"
                 :class="{ 'is-invalid': form.errors.has('allowable_mistakes_count') }">
          <has-error :form="form" field="allowable_mistakes_count"></has-error>
        </div>
      </div>

      <!-- Submit Button -->
      <div class="form-group row">
        <div class="col-md-9 ml-md-auto">
          <v-button type="success" :loading="form.busy">{{ $t('create') }}</v-button>
        </div>
      </div>
    </form>
  </admin-card>

</template>

<script>
  import { mapGetters } from 'vuex'
  import { Form } from 'vform'
  import AdminPage from "../admin-page";

  export default {
    metaInfo () {
      return { title: this.$t('add_test') }
    },
    extends: AdminPage,
    data: () => ({
      form: new Form({
        title: '',
        description: '',
        allowable_mistakes_count: 0
      })
    }),
    methods: {
      async create () {
        const { data } = await this.form.post('/api/admin/tests');
        const testToLessonForm = new Form({
          test_id: data.id,
          lesson_id: this.$route.params.lessonId
        });
        await testToLessonForm.post('/api/admin/lesson-tests');

        // this.$store.dispatch('tests/addTest', { test: data });
        this.$alertify.success(this.$t('admin.global.labels.alert-success'));
      }
    },
  }
</script>
